import { formatSkuDisplay } from './orderInvoiceMath';
import { ikeaImageSrc } from '../../utils/ikeaImage';

function pdfLineImageUrl(row) {
    const raw = row.img ?? row.image ?? '';
    const s = typeof raw === 'string' ? raw.trim() : '';
    if (!s || !/^https?:\/\//i.test(s)) return '';
    return ikeaImageSrc(s);
}

/**
 * @param {Array<Record<string, unknown>>} cartRows
 * @returns {Array<{ name: string; description: string; imageUrl: string; sku: string; qty: number; unitPrice: number; lineTotal: number }>}
 */
export function normalizeCartLinesForPdf(cartRows) {
    if (!Array.isArray(cartRows)) return [];

    return cartRows.map((row) => {
        const qty = Number(row.amount ?? row.quantity ?? 0);
        const unitPrice = Number(row.price ?? 0);
        const lineTotal = Number.isFinite(unitPrice) && Number.isFinite(qty)
            ? unitPrice * qty
            : 0;
        const skuRaw = row.SKU != null ? row.SKU : row.id;
        const description = String(row.description ?? row.imageAlt ?? '').trim();
        return {
            name: String(row.name || '').trim() || 'Item',
            description,
            imageUrl: pdfLineImageUrl(row),
            sku: formatSkuDisplay(skuRaw),
            qty,
            unitPrice,
            lineTotal,
        };
    });
}
